<template>
	<div class="agree">
		<p class="blick-tit" @click="goBack">返回</p>
		<div class="agree-con">
			<h6>用户服务协议</h6>
			<div class="agreeTxt" id="serviceInfo"></div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'agree',
		data() {
			return {
				info: ''
			};
		},
		mounted() {
			this.GetInfo();
		},
		methods: {
			// 返回
			goBack() {
				this.$router.go(-1);
			},
			// 获取用户协议
			GetInfo: function() {
				var that = this;
				that.$api.HtppRequest(
					'WebsiteSet/GetService',
					'GET', {},
					function(res) {
						console.log('获取用户协议');
						console.log(res);
						if (res.code === 0) {
							that.info = res.data.Detail;
							document.getElementById('serviceInfo').innerHTML = res.data.Detail;
						}
					},
					function(res) {}
				);
			}
		}
	};
</script>
<style lang="scss" scoped>
	.agreeTxt {
		overflow: hidden;
		font-size: 14px;
		margin: 30px;
	}

	.agree h6 {
		font-size: 16px;
		text-align: center;
	}

	.agree {
		overflow: hidden;
		width: 1200px;
		padding: 20px;
		margin: 0px auto;
	}

	.agree-con {
		width: 100%;
		background-color: #fff;
		padding: 20px;
		margin: 20px auto;
	}

	.blick-tit {
		font-size: 16px;
		color: #333;
		cursor: pointer;
	}

	.blick-tit:hover {
		opacity: 0.7;
	}
</style>
